import { colorScale } from '@percent/lemonade'

import { RowsData, valueAmount } from '../types/insights.types'
import { tickFormatterFor } from './formatValue'
import { LegendItem } from './metricView'

export const MAP_BUCKET_COLOURS: readonly string[] = [
  colorScale.primary200,
  colorScale.primary300,
  colorScale.primary400,
  colorScale.primary500,
  colorScale.primary600,
]

export const MAP_NO_DATA_COLOUR = colorScale.neutral200

export type MapBucket = { min: number; colour: string }

export const quantileBuckets = (values: readonly number[]): MapBucket[] => {
  const sorted = [...values].sort((a, b) => a - b)
  const count = Math.min(MAP_BUCKET_COLOURS.length, sorted.length)
  const mins = [
    ...new Set(
      Array.from(
        { length: count },
        (_, index) => sorted[Math.floor((index * sorted.length) / count)]
      )
    ),
  ]
  // Fewer buckets take the dark end, so the highest values always read darkest.
  const colours = MAP_BUCKET_COLOURS.slice(
    MAP_BUCKET_COLOURS.length - mins.length
  )

  return mins.map((min, index) => ({ min, colour: colours[index] }))
}

export const bucketColour = (
  buckets: readonly MapBucket[],
  value: number
): string =>
  [...buckets].reverse().find((bucket) => value >= bucket.min)?.colour ??
  MAP_NO_DATA_COLOUR

export const rowsBuckets = (data: RowsData): MapBucket[] =>
  quantileBuckets(data.rows.map((row) => valueAmount(row.value)))

export const mapLegendItems = (
  data: RowsData,
  locale?: string
): LegendItem[] => {
  const format = tickFormatterFor(data.rows[0]?.value, locale)
  const buckets = rowsBuckets(data)

  return buckets.map((bucket, index) => {
    const next = buckets[index + 1]

    return {
      key: `bucket-${index}`,
      label: next
        ? `${format(bucket.min)} - ${format(next.min)}`
        : `${format(bucket.min)} +`,
      color: bucket.colour,
    }
  })
}
